import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Rect, { width: "4", height: "12", x: "2", y: "9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "4", cy: "4", r: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Linkedin";
const Linkedin = memo(themed(Icon));
export {
  Linkedin
};
//# sourceMappingURL=linkedin.js.map
